import React, { useState, useEffect } from 'react';
import Spacer from './Spacer';
import MainQuestionnairItem from './MainQuestionnairItem';
import questionsData from '../data/questions.json';
import VideoPlayer from './VideoPlayer';

function MainQuestionnair({ moveOnToTheNextStep, isActive, group = "A"}) {

    const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [isVideoEnded, setIsVideoEnded] = useState(false);
    const [isVideoGuideHide, setIsVideoGuideHide] = useState(false);

    useEffect(() => {
        // データのシャッフルは useEffect の外で行い、一度だけセット
        const shuffledData = arrayShuffle([...questionsData])
        setFilteredData(shuffledData.filter((item) => (item.group.includes(group))));
    }, [group]);

    // 配列をシャッフルする関数（元の配列を変更しないようにスプレッド演算子を使用）
    const arrayShuffle = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const r = Math.floor(Math.random() * (i + 1));
            [array[i], array[r]] = [array[r], array[i]];
        }
        return array;
    };

    const handleNextButtonClick = () => {
        if (activeQuestionIndex + 1 === filteredData.length) {
            moveOnToTheNextStep();
        } else {
            setIsVideoGuideHide(false);
            setActiveQuestionIndex(activeQuestionIndex + 1);
            setIsVideoEnded(false);
        }
    };

    const activeData = filteredData[activeQuestionIndex] || {};
    const activeVideo360 = isActive ? activeData.video360 : null;

    return (
        <>
            <div className="main-questionnair">
                <div className="questionnair-video" onMouseDown={() => setIsVideoGuideHide(true)} onTouchStart={() => setIsVideoGuideHide(true)}>
                    <h3 className="questionnair-video__title">
                        状況 {activeQuestionIndex + 1}（{activeQuestionIndex + 1}/{filteredData.length}）
                    </h3>
                    <div className={`questionnair-video__guide ${isVideoGuideHide ? "is-hide" : ""} ${isVideoEnded ? "is-video-ended" : ""}`}>
                        <img src={`${process.env.PUBLIC_URL}/images/viewport-guide.svg`} width={200} height={200} alt="画面をドラッグして見渡す" />
                    </div>
                    <div data-vjs-player>
                        {activeVideo360 && (
                            <VideoPlayer
                                videoId={activeData.id}
                                src360={`${process.env.PUBLIC_URL}/videos/${activeVideo360}`}
                                onVideoEnd={() => setIsVideoEnded(true)}
                                isVideoEnded={isVideoEnded}
                                onVideoPlay={() => setIsVideoEnded(false)}
                            />
                        )}
                    </div>
                </div>
                <div className="main-questionnair-items">
                    {filteredData.map((item, index) => (
                        <MainQuestionnairItem
                            key={item.id}
                            data={item}
                            isActive={activeQuestionIndex === index}
                            onButtonClick={handleNextButtonClick}
                            isVideoEnded={isVideoEnded}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default MainQuestionnair;
